import Icon from './icon';
import PropTypes from 'prop-types';
import React from 'react';

function CustomDropdown({ options, setValue, value, ...props }) { // eslint-disable-line require-jsdoc
    const option = options.find(({ value: candidateValue }) => candidateValue === value);

    return (
        <div className="custom-dropdown">
            <span className="h4 custom-dropdown-label">
                {option && option.label}
            </span>
            <Icon name="chevron" />
            <select // eslint-disable-line jsx-a11y/no-onchange
                className="custom-dropdown-select"
                value={value}
                onChange={(event) => setValue(event.target.value)}
                {...props}
            >
                {options.map(({ value, label, disabled }) => (
                    <option key={value} value={value} disabled={disabled}>{label}</option>
                ))}
            </select>
        </div>
    );
}


CustomDropdown.propTypes = {
    options: PropTypes.array.isRequired,
    setValue: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired
};

export default CustomDropdown;
